import axios from "axios";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { FaEye } from "react-icons/fa";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";



import {
    Link,
    useNavigate,
    useParams
} from "react-router-dom";

import Modal from "react-bootstrap/Modal";
import { BsArrowLeft } from "react-icons/bs";
import Loader from "../../../Components/Global/Loader";
import { useAuth } from "../../../Context/AuthContext";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
function OtherCollectionEditAccountPr({ allowedRoles }) {
    const { allowLoading } = useAuthentication(allowedRoles)

    const route = useNavigate();
    const [errorMessage, setErrorMessage] = useState();
    const [total__amount_cal, settotal__amount_cal] = useState(0);
    const [modalPreviewData, setModalPreviewData] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [bankNames, setbankNames] = useState([]);
    const [accountNumbers, setaccountNumbers] = useState([]);
      // api api from global hook 

  const { axiosFetch} = useAxiosFetch();;

    const [totalCalData, settotalCalData] = useState({})
    const [loading, setLoading] = useState(false)
    let { id } = useParams();
    const [tenantData, settenantData] = useState({

        "rent_collection": "",
        "collected_amount": "",
        "deposit_amount": "",
        "bank_name": "",
        "bank_account_number": "",
        "receipt_image": "",


    })
    const [toggleImg, setToggleImg] = useState(false)



    const getbanks = async () => {

        axiosFetch({
            axiosInstance: axios,
            method: "post",
            url: '/bankdetails/list',

            requestConfig: {
                record: 1000

            },
        }).then(res => {
            setbankNames(res?.data?.result?.rows)
        })


    }

    useEffect(() => {
        getbanks()
    }, [])

    const {
        userInfo,
        designation
    } = useAuth();


    useEffect(() => {
        axios
            .get(`/accountant/Collection/cash/view/${id}`)
            .then(function (response) {
                if (response) {
                    setLoading(false);
                    settenantData({ ...tenantData, ...response.data })


                }

            })
            .catch(setLoading(false));

    }, [id])










    const SubmitTenantData = async (e) => {
        setLoading(true)
        e.preventDefault();


       


        const formdata = new FormData();
        formdata.append("image", tenantData?.receipt_image);
        await axios
            .post("/global/fileupload", formdata, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((res) => {
                if (res?.data?.links) {
                    axiosFetch({
                        axiosInstance: axios,
                        method: "post",
                        url: "accountant/Collection/cash/update",
            
                        requestConfig: { ...tenantData, receipt_image: JSON.stringify(res?.data?.links), rent_collection: id ,bank_name:bankNames.find(bank=>(bank.id==tenantData?.bank_id)).bank_name},
                    })

                
                        .then(function (response) {
                            if (response) {
                                setLoading(false);

                                route('/owner/cash-management')
                            }

                        })
                        .catch(setLoading(false));
                } else {

                }
            }).catch(setLoading(false));




    };


    const handleData = (e, editreceipt) => {

        if (editreceipt == "editreceipt") {
            setToggleImg(true)
            let file = e.target.files[0];
            settenantData({ ...tenantData, [e.target.name]: file });

        }
        else {
            if (e.target.name == "receipt_image") {


                let file = e.target.files[0];
                settenantData({ ...tenantData, [e.target.name]: file });

            } else {

                settenantData({ ...tenantData, [e.target.name]: e.target.value });
            }
        }

    };



    useEffect(() => {

        if (tenantData.bank_name == "") {
            return
        } else {
            const finAccountNumbers = bankNames.find(bank => bank.bank_name == tenantData.bank_name)
            if (!finAccountNumbers) {
                return
            } else {

                setaccountNumbers(finAccountNumbers?.account_number)
            }
        }



    }, [tenantData.bank_name])



    const handlereceipt_imageShow = (e) => {

        e.preventDefault();
        if (tenantData?.receipt_image !== undefined) {
            if (tenantData.createdAt) {
                // setModalPreviewData(tenantData?.receipt_image)

                if (toggleImg) {
                    setModalPreviewData(URL.createObjectURL(tenantData?.receipt_image))
                } else {

                    setModalPreviewData(tenantData?.receipt_image)
                }
            } else {

                setModalPreviewData(URL.createObjectURL(tenantData?.receipt_image))
            }




            handleShow(true);
        }




    }



    return (
        <>
            <DashboardLayouts>
                {(loading || allowLoading) && <Loader />}

                {/* --- Section Heading ---- */}
                <div className="breadcrumb row justify-content-between align-items-center">
                    <div className="col-xl-6 d-flex align-items-center dashboard-upper-menu col-md-6 col-auto">
                        <Link
                            to={designation == "Owner" ? "/owner/cash-management" : "/accountant/cash-management"}
                            className="d-flex align-items-center back-link"
                        >
                            <BsArrowLeft className="me-2 back-arrow m-0 " color="black" />
                            <i className="icon-dashboard"></i>
                            <h3 className="mb-0 fw-normal"> Back To Rent Collection</h3>
                        </Link>
                    </div>


                </div>
                {/* ----- Body Content ---- */}


                <form className="dash-form add-form add-building-area">



                    <div className="row">
                        <div className="col">
                            <h1 className="heading-text mb-3 mb-md-5">
                                Rent Collection
                            </h1>
                            <div className="row gy-2 gy-lg-4 gx-xl-5 gx-3">


                                <div className="col-xl-4 col-md-6 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="parking" className="form-lbl">
                                            Total
                                        </label>
                                        <input
                                            // onChange={(e) => setRentData(e.target.value)}
                                            onChange={(e) => handleData(e)}
                                            type="text"
                                            className="form-control form-g1"
                                            id="form-request*"
                                            name="collected_amount"
                                            readOnly
                                            value={tenantData?.collected_amount}
                                            placeholder="Total Amount"
                                        />
                                    </div>
                                </div>

                                <div className="col-xl-4 col-md-6 mb-2 ">
                                    <div className="form-group">
                                        <label htmlFor="" className="form-lbl">
                                            Deposit
                                        </label>
                                        <input
                                            type="text"
                                            value={tenantData?.deposit_amount}
                                            name="deposit_amount"
                                            // readOnly
                                            onChange={(e) => handleData(e)}
                                            className={`form-control form-g1`}
                                            placeholder="Deposit to bank"
                                        />
                                        {errorMessage?.deposit_amount ? (
                                            <div
                                                className="error error-message"
                                                style={{ color: "red" }}
                                            >
                                                {errorMessage?.deposit_amount}
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </div>


                                <div className="col-xl-4 col-md-6 mb-2">
                                    <div className="form-group">
                                    </div>
                                </div>

                                <div className="col-xl-4 col-md-6 mb-2 ">
                                    <div className="form-group">
                                        <label htmlFor="" className="form-lbl">
                                            Choose Bank
                                            <span className="must-field">*</span>
                                        </label>
                                        <select
                                            type="text"
                                            value={tenantData?.bank_id}
                                            name="bank_id"
                                            id="bank_id"
                                            onChange={(e) => handleData(e)}
                                            className={`form-control form-g1`}
                                        >
                                            <option value="">Choose Bank</option>

                                            {
                                                bankNames.map(bn =>
                                                    <option key={bn?.id} value={bn?.id}> {bn?.bank_name}</option>

                                                )
                                            }

                                        </select>


                                    </div>
                                </div>
                                <div className="col-xl-4 col-md-6 mb-2 ">
                                    <div className="form-group">
                                        <label htmlFor="" className="form-lbl">
                                            Account number
                                            <span className="must-field">*</span>
                                        </label>
                                        <select
                                            type="text"
                                            value={tenantData?.bank_account_number}
                                            name="bank_account_number"
                                            id="bank_account_number"
                                            onChange={(e) => handleData(e)}
                                            className={`form-control form-g1`}
                                        >
                                            <option value="">Choose Account number</option>

                                         

                                            {tenantData?.bank_id && bankNames?.find(bank => (bank?.id == tenantData?.bank_id))?.account_number?.map(ac => (<option value={ac}>{ac}</option>))}

                                        </select>


                                    </div>
                                </div>







                                <div className="col-md-4 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="" className="form-lbl">
                                            Upload receipt_image
                                        </label>
                                        <div className="d-flex align-items-center">


                                            {
                                                (tenantData.createdAt) ?
                                                    <div className="position-relative">
                                                        <input
                                                            type="file"
                                                            className={!toggleImg ? "form-control form-g1 me-3 custom__file-input" : "form-control form-g1 me-3 "}
                                                            id="form-request*"
                                                            name="receipt_image"
                                                            title={!toggleImg ? tenantData.receipt_image : tenantData.receipt_image.name}                                                    // accept="image/*"
                                                            // value={readerfile1}
                                                            onChange={(e) => handleData(e, "editreceipt")}
                                                            // onChange={(e) => WorkerUpdate(e, index)}
                                                            placeholder=""
                                                        />
                                                        {!toggleImg && <span className="position-absolute" style={{ top: "27%", right: "15%" }}>...{tenantData.receipt_image?.slice(-7)} </span>}
                                                    </div>
                                                    :
                                                    <input
                                                        type="file"
                                                        className="form-control form-g1 me-3"
                                                        id="form-request*"
                                                        name="receipt_image"
                                                        // accept="image/*"
                                                        // value={setvalue.file}
                                                        onChange={(e) => handleData(e)}
                                                        // onChange={(e) => WorkerUpdate(e, index)}
                                                        placeholder=""
                                                    />
                                            }



                                            <FaEye
                                                onClick={(e) => handlereceipt_imageShow(e)}
                                            />
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div className="row gy-2 gy-lg-4 gx-xl-5 gx-3">


                                <div className="col-xl-12 col-md-6 mt-4 col-md-6">
                                    <button
                                        onClick={(e) => {
                                            SubmitTenantData(e);
                                        }}
                                        type="submit"
                                        className="btn btn-primary btn-lg form-btn add-building-btn mt-3"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={show}
                    onHide={handleClose}
                >
                    <Modal.Header>
                        <Modal.Title
                            id="contained-modal-title-vcenter"
                            className="w-100"
                        >
                            <div className="modal-top">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="heading-text">Payment receipt_image </h3>
                                </div>
                                <div className="">
                                    <div className="buttons d-flex align-items-center">
                                        <div className="form search-bar1 modal-searchbar w-100">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <iframe src={modalPreviewData} width="100%" height="500px" />

                    </Modal.Body>

                </Modal>

            </DashboardLayouts>
        </>
    );
}
export default OtherCollectionEditAccountPr;
